import { useIntl } from '@/intl'
import { Button, Modal, tk, Typography } from '@sunwebgroup/ui-components'
import { styled } from 'styled-components'

const FooterButton = styled(Button)`
  flex-basis: 50%;
`

const ModalBody = styled(Modal.Body)`
  padding: ${tk('spacing_xs')};
  text-align: center;
`

interface LogInModalProps {
  open: boolean
  productId: number | null
  onClose: () => void
}

export function LogInModal({ open, productId, onClose }: LogInModalProps) {
  const intl = useIntl()
  const returnUrl = productId ? encodeURIComponent(`${document.URL}&addFavorite=${productId}`) : encodeURIComponent(document.URL)
  return (
    <Modal.Root open={open} onClose={onClose}>
      <Modal.Content $size="sm">
        <Modal.Header>
          <Modal.HeaderTitle text={intl.formatMessage({ id: 'favorite_login_modal_title' })} />
          <Modal.HeaderCloseButton />
        </Modal.Header>
        <ModalBody>
          <Typography $variant="body-lg">{intl.formatMessage({ id: 'favorite_login_modal_text' })}</Typography>
        </ModalBody>
        <Modal.Footer>
          <FooterButton
            $hierarchy="tertiary"
            $withoutColor
            onClick={() => {
              window.location.href = `/login?returnurl=${returnUrl}`
              onClose()
            }}
          >
            {intl.formatMessage({ id: 'favorite_login_modal_secondary_action_text' })}
          </FooterButton>
          <FooterButton
            $hierarchy="primary"
            onClick={() => {
              window.location.href = `/login?returnurl=${returnUrl}`
              onClose()
            }}
          >
            {intl.formatMessage({ id: 'favorite_login_modal_primary_action_text' })}
          </FooterButton>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  )
}
